var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.announcementMessage != ""
    ? _c("div", { staticClass: "announcement-wrap" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.displayBar && _vm.announcementMessage != "",
                expression: "displayBar && announcementMessage != ''",
              },
            ],
            staticClass: "bo-announcement-bar",
            class: [
              _vm.variant,
              { "slide-up": _vm.slideUp, "slide-down": _vm.slideDown },
            ],
          },
          [
            _c("div", { staticClass: "left-panel" }, [
              _vm.variant == "master" || _vm.variant == "warning"
                ? _c("i", { staticClass: "icon-warning" })
                : _vm.variant == "info"
                ? _c("i", { staticClass: "icon-info" })
                : _vm.variant == "success"
                ? _c("i", { staticClass: "icon-filledcheckcircle" })
                : _vm.variant == "danger"
                ? _c("i", { staticClass: "icon-cancelcircle-1" })
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "announcement" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.announcementMessage) +
                    "\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right-panel" },
              [
                _vm._t("announcement_buttons"),
                _vm._v(" "),
                _c("i", {
                  staticClass: "icon-close",
                  on: { click: _vm.closeAnnouncementBar },
                }),
              ],
              2
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.displayBar,
                expression: "!displayBar",
              },
            ],
            staticClass: "announcement-expand",
            on: { click: _vm.openAnnouncementBar },
          },
          [_c("i", { staticClass: "icon icon-chevronright" })]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }